const ProjectDetailsSkeleton = () => (
  <div className="space-y-6 animate-pulse p-2">
    {/* Header Skeleton */}
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="space-y-3">
          <div className="h-4 w-28 rounded-full bg-slate-200" />
          <div className="h-7 w-72 rounded-xl bg-slate-200" />
          <div className="h-4 w-96 rounded-lg bg-slate-100" />
        </div>
        <div className="flex gap-2">
          <div className="h-10 w-28 rounded-xl bg-slate-200" />
          <div className="h-10 w-32 rounded-xl bg-slate-200" />
        </div>
      </div>
    </div>

    {/* Tabs Skeleton */}
    <div className="flex gap-2 border-b border-slate-200 pb-2">
      <div className="h-9 w-28 rounded-xl bg-slate-200" />
      <div className="h-9 w-28 rounded-xl bg-slate-200" />
      <div className="h-9 w-28 rounded-xl bg-slate-200" />
      <div className="h-9 w-28 rounded-xl bg-slate-200" />
    </div>

    {/* Cards Grid Skeleton */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="h-28 rounded-2xl bg-slate-200/80" />
      <div className="h-28 rounded-2xl bg-slate-200/80" />
      <div className="h-28 rounded-2xl bg-slate-200/80" />
    </div>

    {/* Details Table Skeleton */}
    <div className="rounded-3xl border border-slate-200 bg-white p-6 space-y-4">
      <div className="h-6 w-44 rounded-lg bg-slate-200" />
      <div className="h-12 w-full rounded-xl bg-slate-100" />
      <div className="h-12 w-full rounded-xl bg-slate-100" />
      <div className="h-12 w-full rounded-xl bg-slate-100" />
    </div>
  </div>
);

export default ProjectDetailsSkeleton;
